<s1-modal #modal [title]="'walletModal.title'">
  <leu-customer-wallet-section [customer]="customer"></leu-customer-wallet-section>
</s1-modal>